// src/components/files/chargerPdfjs.ts — SCE Issues
// pdf.js et son worker, chargés une fois et à la demande : par le lecteur de
// la visionneuse (LecteurPdf) et par l'annotation d'un PDF (EditeurAnnotation).
// La version « legacy » tourne aussi sur les Safari un peu anciens.

type Pdfjs = typeof import('pdfjs-dist')

let chargement: Promise<Pdfjs> | null = null

export function chargerPdfjs(): Promise<Pdfjs> {
  chargement ??= (async () => {
    const [pdfjs, worker] = await Promise.all([
      import('pdfjs-dist/legacy/build/pdf.mjs'),
      import('pdfjs-dist/legacy/build/pdf.worker.min.mjs?url'),
    ])
    pdfjs.GlobalWorkerOptions.workerSrc = worker.default
    return pdfjs as Pdfjs
  })().catch((e: unknown) => {
    // Réseau coupé pendant le chargement : la prochaine ouverture réessaie.
    chargement = null
    throw e
  })
  return chargement
}
